import { UserRoles } from '@/constants/users';

const isExternalCollaborator = (user) => {
  return UserRoles.EXTERNAL_COLLABORATOR === user?.role;
};

export default isExternalCollaborator;
